import { createStyles } from 'antd-style'

export default createStyles(() => {
  return {
    row: {
      display: 'grid',
      gridTemplateColumns:
        '1.5fr fit-content(100%) repeat(4, 1fr) fit-content(100%)',
    },
  }
})
